<div class="ss-r-btn">
  <app-icon-button color="#e2fbf4">
    <svg xmlns="http://www.w3.org/2000/svg" width="22" viewBox="0 0 39 26">
      <path id="Path_38" data-name="Path 38" d="M33.333,15.75V8.167A2.173,2.173,0,0,0,31.167,6h-26A2.173,2.173,0,0,0,3,8.167V29.833A2.173,2.173,0,0,0,5.167,32h26a2.173,2.173,0,0,0,2.167-2.167V22.25L42,30.917V7.083Z" transform="translate(-3 -6)" fill="#20243e"/>
    </svg>
  </app-icon-button>
  <span class="ss-r-active" *ngIf="status"></span>
</div>